import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASEURI, headers } from "../../utils/helper";

const initialState = {
  chat: {},
  socket: null,
  appointmentAvailability: {},
  appointmentUnreadCount: 0,
  messagesUnreadCount: 0,
}
const socket = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setSocket: (state, { payload }) => {
      state.socket = payload
    },
    setCurrectChat: (state, { payload }) => {
      state.chat = payload
    },
    setAppointmentAvailability: (state, { payload }) => {
      state.appointmentAvailability = payload
    },
    setAppointmentUnreadCount: (state, { payload }) => {
      state.appointmentUnreadCount = Math.max(0, payload || 0);
    },
    setMessagesUnreadCount: (state, { payload }) => {
      state.messagesUnreadCount = Math.max(0, payload || 0);
    },
    incrementMessagesUnreadCount: (state, { payload }) => {
      state.messagesUnreadCount = state.messagesUnreadCount + (payload || 1);
    },
    decrementMessagesUnreadCount: (state, { payload }) => {
      state.messagesUnreadCount = Math.max(0, state.messagesUnreadCount - (payload || 1));
    },
    updateCurrentChatAppointmentStatus: (state, { payload }) => {
      const currentAppointmentId = state.chat?.appointmentId || state.chat?.appointment?._id;
      if (currentAppointmentId && currentAppointmentId.toString() === payload.appointmentId?.toString()) {
        state.chat.appointmentStatus = payload.status;
        if (state.chat.appointment) {
          state.chat.appointment.appointmentStatus = payload.status;
        }
      }
    },
  }
})

export const fetchAppointmentUnreadCount = () => async (dispatch) => {
  try {
    const res = await axios.get(`${BASEURI}/user/appointment-chat/unread-count`, {
      headers: headers()
    });
    if (res.data?.success) {
      dispatch(setAppointmentUnreadCount(res.data.data?.unreadCount || 0));
    }
  } catch (error) {
    console.error("Error fetching appointment unread count:", error);
  }
};

export const fetchMessagesUnreadCount = () => async (dispatch) => {
  try {
    const res = await axios.get(`${BASEURI}/user/chat/unread-count`, {
      headers: headers()
    });
    if (res.data?.success) {
      dispatch(setMessagesUnreadCount(res.data.data?.unreadCount || 0));
    }
  } catch (error) {
    // Quietly log error if endpoint differs
    console.error("Error fetching direct messages unread count:", error);
  }
};

export const {
  setSocket,
  setCurrectChat,
  setAppointmentAvailability,
  setAppointmentUnreadCount,
  setMessagesUnreadCount,
  incrementMessagesUnreadCount,
  decrementMessagesUnreadCount,
  updateCurrentChatAppointmentStatus,
} = socket.actions
export default socket.reducer